import { render } from "./OwlCarousel.vue?vue&type=template&id=2e184293"
import script from "./OwlCarousel.vue?vue&type=script&lang=js"
export * from "./OwlCarousel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__